import React from 'react'

/** Secao Dados: a base cadastral e o historico que alimentam os modulos. */
export function SecaoDadosIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 24 24"
    >
      <ellipse
        cx="12"
        cy="5.8"
        rx="7"
        ry="2.9"
        stroke="#fff"
        strokeWidth="1.6"
      />
      <path
        d="M5 5.8v12.4c0 1.6 3.13 2.9 7 2.9s7-1.3 7-2.9V5.8M5 12c0 1.6 3.13 2.9 7 2.9s7-1.3 7-2.9"
        stroke="#fff"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  )
}
